export const showSearchLayer = visible => ({
  type: "SHOW_SEARCH_LAYER",
  visible
});

export const setLanguage = language => {
  let lng = language.toLowerCase();
  localStorage.setItem("lng", lng);

  return {
    type: "SET_LANGUAGE",
    language: lng
  };
};

export const setBreadCrumbs = payload => ({
  type: "SET_BREAD_CRUMBS",
  payload
});

export const setCurrentNavPage = currentNavPage => ({
  type: "SET_CURRENT_NAV_PAGE",
  currentNavPage
});

export const pushSourceToken = (sourceName, sourceToken) => ({
  type: "PUSH_SOURCE_TOKEN",
  sourceName,
  sourceToken
});

export const clearSourcesTokens = (sourceName, sourceToken) => ({
  type: "CLEAR_SOURCES_TOKENS"
});

export const setAppIsEmbedded = embedded => ({
  type: "SET_APP_IS_EMBEDDED",
  embedded
});

export const setSubMenuDirection = subMenuDirection => ({
  type: "SET_SUB_MENU_DIRECTION",
  subMenuDirection
});
export const setSubMenuDirectionToggle = subMenuDirectionToggle => ({
  type: "SET_SUB_MENU_DIRECTION_TOGGLE",
  subMenuDirectionToggle
});



// WEBPACK FOOTER //
// ./src/actions/actions/params.js